import { Box, IconButton, Stack, Typography } from '@mui/material';

import { SettingsCategoryProps } from './SettingsCategory.interface';
import {
  ContentContainer,
  Divider,
  LightTooltip,
} from './SettingsCategory.styled';

export const SettingsCategory = (props: SettingsCategoryProps) => {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h5">{props.title}</Typography>

        {props.icon && (
          <LightTooltip title={props.iconText} placement="top-end" arrow={true}>
            <IconButton disableRipple>{props.icon}</IconButton>
          </LightTooltip>
        )}
      </Stack>

      <Divider />

      <>{props.children}</>
    </Box>
  );
};

SettingsCategory.Content = function SettingCategoryContent(props: {
  title?: string;
  children: React.ReactNode;
}) {
  return (
    <Box>
      {props.title && <Typography variant="h6">{props.title}</Typography>}

      <ContentContainer>{props.children}</ContentContainer>
    </Box>
  );
};
